module.exports = __webpack_public_path__ + "img/icon-3-6a2d3f21.png";